/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonAddressSummaryInfo } from './BabylonAddressSummaryInfo';
import type { BabylonProposalTimeInfo } from './BabylonProposalTimeInfo';
import type { BabylonProposalVoteInfo } from './BabylonProposalVoteInfo';

export type BabylonProposalDetailInfo = {
    PPLID: string;
    EXP: BabylonProposalDetailInfo.EXP;
    STAT: BabylonProposalDetailInfo.STAT;
    TTL: string;
    TPLIST: Array<string>;
    VT: BabylonProposalTimeInfo;
    PPR: BabylonAddressSummaryInfo;
    DPSTT: BabylonProposalTimeInfo;
    INITDPST: string;
    TDPST: string;
    SBMTT: number;
    SBMTTRXHA: string;
    VOTLIST: Array<BabylonProposalVoteInfo>;
    TVAMT: string;
    TSTKAMT: string;
    TNT: string;
    QRM: string;
    APTHR: string;
    SMR: string;
};

export namespace BabylonProposalDetailInfo {

    export enum EXP {
        Y = 'Y',
        N = 'N',
    }

    export enum STAT {
        UNSPECIFIED = 'UNSPECIFIED',
        DEPOSIT_PERIOD = 'DEPOSIT_PERIOD',
        VOTING_PERIOD = 'VOTING_PERIOD',
        PASSED = 'PASSED',
        REJECTED = 'REJECTED',
        FAILED = 'FAILED',
    }


}

